const LangRewardsCard = {
  "rewardsCard.btn._redeemVoucher": ["Exchange all my stamps for cash voucher"]
};

export default LangRewardsCard;
